module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lzg1L"))).then(() => parcelRequire('hEqeo'));